"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FloatStyles.Float;
  }
});

var _FloatStyles = require("./Float-styles");